import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import * as dateFns from 'date-fns';

import { newIdGenerated, stringIsNumber } from '../../helpers/helpers';
import { TimeSelectorProps } from './types';

const TimeSelector = (
  { time, applyChanges, index, customStyle, customClass = '', message = ''} : TimeSelectorProps
) => {

  const [hours, setHours] = useState(time ? dateFns.format(time, 'hh') : '');
  const [minutes, setMinutes] = useState(time ? dateFns.format(time, 'mm') : '');
  const [seconds, setSeconds] = useState(time ? dateFns.format(time, 'ss') : '');
  const [am, setAm] = useState(time ? dateFns.format(time, 'a') : '');
  const [show, setShow] = useState(false);

  const onOpen = () => {
    setHours(dateFns.format(time, 'hh'));
    setMinutes(dateFns.format(time, 'mm'));
    setSeconds(dateFns.format(time, 'ss'));
    setAm(dateFns.format(time, 'a'));
  };

  const formatTimeString = (str: string) => str.length === 1 ? '0' + str : str;
  const isValidHour = (hour: number) => hour >= 1 && hour <= 12;
  const isValidMinute = (minute: number) => minute >= 0 && minute <= 59;
  const isValidSecond = (second: number) => second >= 0 && second <= 59;

  const handleHourChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.value === '' || event.target.value === '0') {
      setHours('');
    } else if (stringIsNumber(event.target.value) && isValidHour(parseInt(event.target.value))) {
      setHours(formatTimeString(parseInt(event.target.value).toString()));
    }
  };

  const handleMinuteChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.value === '' || (event.target.value === '0' && minutes === '00')) {
      setMinutes('');
    } else if (stringIsNumber(event.target.value) && isValidMinute(parseInt(event.target.value))) {
      setMinutes(formatTimeString(parseInt(event.target.value).toString()));
    }
  };

  const handleSecondChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.value === '' || (event.target.value === '0' && seconds === '00')) {
      setSeconds('');
    } else if (stringIsNumber(event.target.value) && isValidSecond(parseInt(event.target.value))) {
      setSeconds(formatTimeString(parseInt(event.target.value).toString()));
    }
  };

  const handleApplyClick = () => {
    if (!Number.isNaN(+(index as number))) {
      applyChanges(parseInt(hours), parseInt(minutes), parseInt(seconds), am === 'AM', index);
    } else {
      applyChanges(parseInt(hours), parseInt(minutes), parseInt(seconds), am === 'AM');
    }
  };

  const handleToggle = (event: boolean) => {
    if (event) {
      onOpen();
      setShow(true);
    } else {
      setShow(false);
    }
  };

  const idPm = newIdGenerated('id-pm-generated-');
  const idAm = newIdGenerated('id-pm-generated-');
  const tooltipMessage = message ? message : null;

  return (
    <div className="timep time-selector-dropdown" data-tooltip={tooltipMessage} style={{ height: '20px' }}>
      <Dropdown className="timep-01" show={show} onToggle={event => handleToggle(event)}>
        <Dropdown.Toggle id="dropdown-basic" className={`btn-gray-l ${customClass}`} style={{ padding: '0px 8px', ...customStyle }}>
          {dateFns.format(time, 'hh:mm:ss a')}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <div className="t-title">TYPE IN A TIME</div>
          <div className="timep-03">
            <div style={{ display: 'flex' }}>
              <div style={{ width: '45%' }}>
                <input
                  className="input-time" type="text" value={hours}
                  onChange={(event) => handleHourChange(event)}
                />
                <p className="p-ii">Hour</p>
              </div>
              <div style={{ width: '10%', textAlign: 'center' }} className="two-points">
                :
              </div>
              <div style={{ width: '45%' }}>
                <input
                  className="input-time" type="text" value={minutes}
                  onChange={(event) => handleMinuteChange(event)}
                />
                <p className="p-ii">Minute</p>
              </div>
              <div style={{ width: '10%', textAlign: 'center' }} className="two-points">
                :
              </div>
              <div style={{ width: '45%' }}>
                <input
                  className="input-time" type="text" value={seconds}
                  onChange={(event) => handleSecondChange(event)}
                />
                <p className="p-ii">Second</p>
              </div>
            </div>
            <div className="check-01 radio">
              <p>
                <input id={idAm} type="radio" checked={am === 'AM'} onChange={() => setAm('AM')} />
                <label style={{ marginLeft: '15px' }} htmlFor={idAm} className="radio-label">AM</label>
              </p>
              <p>
                <input id={idPm} type="radio" checked={am === 'PM'} onChange={() => setAm('PM')} />
                <label style={{ marginLeft: '15px' }} htmlFor={idPm} className="radio-label">PM</label>
              </p>
            </div>
          </div>
          <div className="footer-s">
            <button className="btn-transparet" onClick={() => setShow(false)}>Cancel</button>
            <button
              className="btn-blue"
              onClick={() => {
                handleApplyClick();
                setShow(false);
              }}
            >Apply
            </button>
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default TimeSelector;